import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, updateData) =>
  await AxiosConfig.create('post', url).call(updateData).getResponseData();

function usePatchNoteUpdate(updateData) {
  const { data, _error, isLoading, isValidating, mutate } = useSWR(
    updateData ? `/patchnote/update` : null,
    (url) => fetcher(url, updateData),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    patchNotes: data,
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default usePatchNoteUpdate;
